/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'company-hub.search-extension.custom-search-config-panel.corner-style-label': 'Hjørner',
  'company-hub.search-extension.custom-search-config-panel.default-placeholder-text':
    'Søg efter bekræftede meddelelser, ressourcer og politikker',
  'company-hub.search-extension.custom-search-config-panel.filters-title': 'Filtre',
  'company-hub.search-extension.custom-search-config-panel.placeholder-text-label': 'Midlertidig text',
  'company-hub.search-extension.custom-search-config-panel.placeholder-tooltip-label':
    'Tilpas prompten, som dine læsere vil se',
  'company-hub.search-extension.custom-search-config-panel.preamble': 'Tilføj et felt til filtreret søgning',
  'company-hub.search-extension.custom-search-config-panel.round-corner-style-label': 'Rundt',
  'company-hub.search-extension.custom-search-config-panel.sharp-corner-style-label': 'Firkant',
  'company-hub.search-extension.custom-search-config-panel.styles-fill-color-label': 'Fyldfarve',
  'company-hub.search-extension.custom-search-config-panel.styles-text-color-label': 'Tekstfarve',
  'company-hub.search-extension.custom-search-config-panel.styles-title': 'Stile',
  'company-hub.search-extension.custom-search-config-panel.title': 'Brugerdefineret søgning',
  'company-hub.search-extension.manifest.default-placeholder-text':
    'Søg efter bekræftede meddelelser, ressourcer og politikker',
  'company-hub.search-extension.manifest.macro-description': 'Tilføj et felt til filtreret søgning',
  'company-hub.search-extension.manifest.macro-title': 'Brugerdefineret søgning',
  'company-hub.search-extension.more-button': 'Vis flere resultater',
};
